import {reqPackageCodes,} from "../api";
//二连浩特
export const CUSTOMS_PORT_Erlianhaote = 'ErLianhaote';
export const PATH_NAME = {
    /*
     '/': '订单管理',
     '/goodsList': '货物管理',
     '/trackList': '物流信息管理',
     */
};
export const DEMESTIC_ORDER_STATUS = {
    new: '新建',
    failed: '已驳回',
    commit: '待审核',
    pass: '已审核',
    collect: '已上门',
    send: '运输中',
    arrive: '已抵达',
    discharge: '已卸货',
    cancelled: '已取消'
};
export const ORDER_STATUS = {
    new: '新建',
    failed: '已驳回',
    audit: '待审核',
    audited: '待订舱',
    booked: '已订舱',
    boxed: '已装箱',
    declare: '待报关',
    declaring: '报关中',
    released: '已放行',
    cancelled: '已取消'
};
export const LOGISTICS_STATUS = {
    waiting: "待提货",
    transport: '运输中',
    boxed: '已装箱',
    declaring: '报关中',
    released: '已放行',
    destination: '已到达',
    cancelled: '已取消'
};
export const DEFAULT_CUSTOMS_CODE = {
    N: 'Alashankou', T: 'Khorgos', G: 'GanZhou', M: 'Manchuria', X: 'Urumqi', K: 'Kashgar', Z: 'Khorgos', A: 'Khorgos',
    D: 'Khorgos', YT: 'YiNing', YE: 'YiNing', YZ: 'YiNing',
};
export const DEFAULT_CUSTOMS_NAME = {
    N: '阿拉山口', T: '霍尔果斯', G: '赣州', M: '满洲里', X: '乌鲁木齐', K: '喀什(卡拉苏)', Z: '霍尔果斯', A: '霍尔果斯',
    D: '霍尔果斯', YT: '伊宁', YE: '伊宁', YZ: '伊宁'
};
export const DELIVERY_TYPE = {
    YT: '伊宁TIR', YE: '伊宁中俄班列', YZ: '伊宁中亚班列',
    Z: '霍欧中铁班车', T: '中欧特快', D: '亚欧直达', A: '中哈欧空运', N: '公铁联运', K: '南疆快线', X: '新疆班列', /* M: '满欧快线', G: '赣州班列'*/
};
//运输类型：既有公路又有铁路(班列):班次管理
export const PLAN_DELIVERY_TYPE = {YE: '伊宁中俄班列', YZ: '伊宁中亚班列', X: '新疆班列',};
//运输类型：既有公路又有铁路(不含亚欧直达、新疆班列):铁路计划管理
export const TRAIN_PORT_DELIVERY_TYPE = {Z: '霍欧中铁班车', N: '公铁联运'};
//运输类型：既有公路又有铁路
export const DELIVERY_TYPE_MIX = {
    YE: '伊宁中俄班列', YZ: '伊宁中亚班列', Z: '霍欧中铁班车', D: '亚欧直达', N: '公铁联运', /* G: '赣州班列'*/X: '新疆班列',
};
//运输类型：仅公路
export const DELIVERY_TYPE_HIGHWAY = {YT: '伊宁TIR', T: '中欧特快', K: '南疆快线',  /*M: '满欧快线'*/};
//运输类型：含空运
export const DELIVERY_TYPE_AIR = {A: '中哈欧空运'};
//特快的一箱到底A 跟公铁联运很像
export const SUB_TYPE = {A: '一箱到底', B: '倒装运输'};
export const TRANSFER_TYPE_N = {w2w: '仓到仓', w2s: '仓到站', s2s: '站到站', s2w: '站到仓'};//DELIVERY_TYPE_MIX除了D
export const TRANSFER_TYPE_D = {w2w: '仓到仓', w2s: '仓到站', p2s: '口岸到站', p2w: '口岸到仓'};//DELIVERY_TYPE=D
export const TRANSFER_TYPE_T = {w2w: '仓到仓', w2p: '仓到口岸', p2p: '口岸服务', s2w: '口岸到仓'};
export const TRANSFER_TYPE_A = {
    w2w: '仓到仓',
    w2as: '仓到启运机场',
    w2a: '仓到目的机场',
    p2p: '口岸服务',
    p2as: '口岸到启运机场',
    p2a: '口岸到目的机场',
    p2w: '口岸到仓'
};
export const IN_PERSON = {D: '我司代办', Z: '自办',};
//客户账单：结算状态
export const SETTLEMENT_STATUS = {Y: '已结算', N: '未出账', C: '已出账'};
//实报实销账单：客户状态
export const CLIENT_STATUS = {new: '未出账', accountOut: '已出帐', complete: '已结算'};
//包装类型
//export const PACKAGE_TYPE = {EC: 'EC (塑料袋)', CT: 'CT (硬纸板盒子)', '5H': '5H (聚合编织袋)',};
const getPackageCodesData = async () => {
    let result = await reqPackageCodes();
    if (result.code === 200) {
        const data = {};
        result.data.forEach((o) => {
            data[o.packageType] = o.packageTypeName;
        });
        return data
    }
    return null
};
export let PACKAGE_TYPE = {};
export const getPackageCodes = () => {
    getPackageCodesData().then(res => {
        if (res != null) {
            PACKAGE_TYPE = res
        }
    })
};
//刷新会重新获取
getPackageCodes();

//****  进口   ****//
//订单状态
export const I_ORDER_STATUS = {
    new: '新建',
    commit: '待审核',
    failed: '已驳回',
    audited: '待抵达',
    arrive: '待报关',
    declared: '待放行',
    released: '已放行',
    complete: '已完成',
    cancelled: '已取消'
};
//物流状态
export const I_LOGISTICS_STATUS = {
    audited: '待抵达',
    arrive: '待提箱',
    collect: '待放行',
    declared: '转关待放行',
    released: '待发车',
    sentOut: '待运抵',
    destination: '待卸货',
    complete: '已完成'
};
//运输类型
export const I_DELIVERY_TYPE = {YIN: '伊宁班列进口', YIT: '伊宁TIR进口'};
//委托方式
export const I_ENTRUST_TYPE_YIN = {p2p: '口岸服务', p2w: '口岸到仓', p2d: '转关服务'};
export const I_ENTRUST_TYPE_YIT = {p2p: '口岸服务', p2w: '口岸到仓'};
export const I_ENTRUST_TYPE = {YIN: I_ENTRUST_TYPE_YIN, YIT: I_ENTRUST_TYPE_YIT};
//服务类型
export const I_SUB_TYPE_YIN = {A: '整箱'};
export const I_SUB_TYPE_YIT = {A: '整箱', B: '倒装'};
export const I_SUB_TYPE = {YIN: I_SUB_TYPE_YIN, YIT: I_SUB_TYPE_YIT};

export default {
    //订单状态
    I_ORDER_STATUS,
    //物流状态
    I_LOGISTICS_STATUS,
    //运输类型
    I_DELIVERY_TYPE,
    //委托方式
    I_ENTRUST_TYPE_YIN,
    I_ENTRUST_TYPE_YIT,
    I_ENTRUST_TYPE,
    //服务类型
    I_SUB_TYPE_YIN,
    I_SUB_TYPE_YIT,
    I_SUB_TYPE,
    //筛选
    SEARCH: {
        deliveryType: {name: '运输类型', source: 'I_DELIVERY_TYPE'},
        entrustType: {name: '委托方式', source: 'I_ENTRUST_TYPE_YIN'},
        subType: {name: '服务类型', source: 'I_SUB_TYPE_YIT'},
        estimatePortDt: {name: '预计抵达时间',},
        declaredDt: {name: '清关/转关时间',},
        boxNo: {name: '集装箱号',},
        ladingBillNo: {name: '提单号',},
        orderStatus: {name: '订单状态', source: 'I_ORDER_STATUS'},
        logisticsStatus: {name: '物流状态', source: 'I_LOGISTICS_STATUS'},
    },
}